import { Box, Button, Card, CardBody, CardHeader, Container, FormControl, FormLabel, Heading, Input, Stack, useToast } from '@chakra-ui/react'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Login from './components/Login'
import NotFound from './components/NotFound'
import { ChakraProvider, Tabs, TabList, TabPanels, Tab, TabPanel, Spinner, Center } from '@chakra-ui/react';
import WatchList from './components/WatchList';
import CustomStrategySymbols from './components/CustomStrategySymbols';
import OptionPositions from './components/OptionPositions';
import ManualOrder from './components/ManualOrder';
import theme from './theme';

// 设置 axios 默认配置
axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;

// 添加响应拦截器处理 token 过期
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          await axios.post('/verify-token');
          setIsAuthenticated(true);
        } catch (error) {
          localStorage.removeItem('token');
          delete axios.defaults.headers.common['Authorization'];
          setIsAuthenticated(false);
        }
      }
      setIsLoading(false);
    };

    initAuth();
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const PrivateRoute = ({ children }) => {
    if (isLoading) {
      return (
        <Center h="100vh">
          <Spinner size="xl" />
        </Center>
      );
    }
    return isAuthenticated ? children : <Navigate to="/login" />;
  };

  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login onLoginSuccess={handleLogin} />} />
          <Route path="/" element={
            <PrivateRoute>
              <Box p={4}>
                <Tabs>
                  <TabList>
                    <Tab>观察列表</Tab>
                    <Tab>自定义策略</Tab>
                    <Tab>期权持仓</Tab>
                    <Tab>手动下单</Tab>
                  </TabList>

                  <TabPanels>
                    <TabPanel>
                      <WatchList />
                    </TabPanel>
                    <TabPanel>
                      <CustomStrategySymbols />
                    </TabPanel>
                    <TabPanel>
                      <OptionPositions />
                    </TabPanel>
                    <TabPanel>
                      <ManualOrder />
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Box>
            </PrivateRoute>
          } />
        </Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;